import * as React from 'react';

import { withIntl, IntlProps } from 'ha/i18n';
import { HOME } from 'ha/constants/pageNames';

import withCurrentPageName, {
  PageNameProps,
} from 'ha/helpers/withCurrentPageName';
import Track from 'ha/components/track/SmartTrack';
import Link from 'ha/ui/next/Link';
import Button from 'ha/ui/next/Button';

export const HowItWorksLink: React.SFC<IntlProps & PageNameProps> = ({
  intl: { urlResolver, T },
  pageName,
}) => (
  <Track name="Clicked How It Works in header" type="button">
    <Link
      to={urlResolver.getRenting()}
      rel={pageName !== HOME ? 'no-follow' : ''}
    >
      <Button data-test-locator="How It Works NavBar Btn" variant="text">
        {T('how_it_works_breadcrumb')}
      </Button>
    </Link>
  </Track>
);

export default withCurrentPageName(withIntl(HowItWorksLink));
